import { useTranslation } from "@i18n/hooks";
import {
	type SelectMultiplePublishedRootFieldProps,
	type SelectMultiplePublishedRootFieldState,
} from "./select-multiple-published-root-field.types";
import { SelectComplexDataField } from "../../../components/select-complex-data-field";
import { SearchablePublishedRootTable } from "../searchable-published-root-table";

export const SelectMultiplePublishedRootField = ({
	...props
}: SelectMultiplePublishedRootFieldProps) => {
	const { t } = useTranslation("common");
	return (
		<>
			<SelectComplexDataField<SelectMultiplePublishedRootFieldState>
				valuePlaceholder={t("course.noCoursesSelected")}
				actionButtonLabel={t("course.selectCourses")}
				headerLabel={t("course.selectAtLeastOneCourse")}
				{...props}
			>
				<SearchablePublishedRootTable
					selection={props.fieldValue}
					onChange={props.updateField}
					selectionMode="multiple"
				/>
			</SelectComplexDataField>
		</>
	);
};
